"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHPreloadScene = void 0;
const KHContainer_1 = require("./KHContainer");
const WebFont = require("webfontloader");
class KHPreloadScene extends Phaser.Scene {
    constructor(key = "KHPreloadScene") {
        super(key);
        this.current_percent = 0;
    }
    preload() {
        this.cachedPalette = this.palette();
        this.game_width = Number(this.game.config.width);
        this.game_height = Number(this.game.config.height);
        const size = this.loadBarSize(this.game_width, this.game_height);
        const width = size[0];
        const height = size[1];
        const containerWidth = Math.floor((this.game_width - width) / 2);
        const containerHeight = Math.floor((this.game_height - height) / 2);
        this.loadBarContainer = new KHContainer_1.KHContainer(this, containerWidth, containerHeight, width, height, this.cachedPalette[1], 1, 0, false);
        this.add.existing(this.loadBarContainer);
        this.loadBar = this.add.graphics();
        this.loadBarContainer.add(this.loadBar);
        this.cameras.main.setBackgroundColor(this.cachedPalette[0]);
        this.load.on('progress', (value) => {
            this.setProgress(value);
        });
        this.loadAssets();
    }
    create() {
        this.setProgress(1);
        const fonts = this.fontsToLoad();
        if (fonts == null || fonts.length == 0) {
            this.startScene();
        }
        else {
            WebFont.load({
                custom: {
                    families: fonts
                },
                active: () => {
                    this.startScene();
                }
            });
        }
    }
    setProgress(percent) {
        percent = Math.max(this.current_percent, Math.min(percent, 1));
        const inset = Math.floor(this.loadBarContainer.c_h * .1);
        this.loadBar.clear();
        this.loadBar.fillStyle(this.cachedPalette[2]);
        const w = this.loadBarContainer.c_w - inset * 2, h = this.loadBarContainer.c_h - (inset * 2);
        this.loadBar.fillRect(inset, inset, Math.floor(percent * w), h);
        const logo = [
            [0, 0, 0, 0],
            [1, 1, 1, 1],
            [0, 0, 0, 1],
            [1, 1, 1, 1],
            [0, 1, 0, 1],
            [1, 0, 0, 1],
            [1, 1, 1, 1],
            [0, 0, 0, 0],
        ];
        this.drawBoxArray(this.loadBar, this.cachedPalette[1], logo, inset, inset, w, h);
    }
    drawBoxArray(graphics, col, arr, x, y, w, h) {
        const boxes_width = arr[0].length;
        const boxes_height = arr.length;
        const box_width = h / boxes_height;
        const all_width = box_width * boxes_width;
        const s_x = (w - all_width) / 2 + x;
        graphics.fillStyle(col);
        for (let i = 0; i < arr.length; i++) {
            for (let j = 0; j < arr[i].length; j++) {
                if (arr[i][j]) {
                    graphics.fillRect(s_x + box_width * j, y + box_width * i, box_width, box_width);
                }
            }
        }
    }
    /**
     * Size of the loading bar. Default is based on the size of the screen.
     * @param width Width of the screen.
     * @param height Height of the screen.
     * @returns [width, height]
     */
    loadBarSize(width, height) {
        // The flooring and multiplying ensure that everything looks crisp with
        // my logo at all resolutions by default (hopefully). It's ensured to be
        // a multiple of 10 for the 8 vertical pixels of my logo + the two for inset.
        return [Math.floor(width / 2), Math.floor(Math.max(1, Math.floor(height / 5) / 10)) * 10];
    }
    startScene() {
        this.preloadFinished();
        this.scene.start(this.nextScene(), null);
    }
    preloadFinished() {
        // Override and do anything you want to do before first proper scene runs.
    }
    nextScene() {
        return "";
        // Override and return scene name.
    }
    loadAssets() {
        // Override and load assets.
    }
    fontsToLoad() {
        // Override and return font names, if any.
        return [];
    }
    /**
     * Color palette for the loading scene. [BG color, load bar color, logo color]
     */
    palette() {
        return [0x000000, 0x111111, 0x7d007e];
    }
}
exports.KHPreloadScene = KHPreloadScene;
